/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roster_No_BookingsInputs */

const en_roster_no_bookings = /** @type {(inputs: Roster_No_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No bookings yet`)
};

const es_roster_no_bookings = /** @type {(inputs: Roster_No_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay reservas aún`)
};

const fr_roster_no_bookings = /** @type {(inputs: Roster_No_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune réservation pour le moment`)
};

const de_roster_no_bookings = /** @type {(inputs: Roster_No_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Buchungen`)
};

const id_roster_no_bookings = /** @type {(inputs: Roster_No_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada pemesanan`)
};

/** @type {(inputs: Roster_No_BookingsInputs) => LocalizedString} */
const ja_roster_no_bookings = en_roster_no_bookings;

/** @type {(inputs: Roster_No_BookingsInputs) => LocalizedString} */
const zh_roster_no_bookings = en_roster_no_bookings;

/** @type {(inputs: Roster_No_BookingsInputs) => LocalizedString} */
const ar_roster_no_bookings = en_roster_no_bookings;

/** @type {(inputs: Roster_No_BookingsInputs) => LocalizedString} */
const it_roster_no_bookings = en_roster_no_bookings;

/** @type {(inputs: Roster_No_BookingsInputs) => LocalizedString} */
const ru_roster_no_bookings = en_roster_no_bookings;

/** @type {(inputs: Roster_No_BookingsInputs) => LocalizedString} */
const pt_roster_no_bookings = en_roster_no_bookings;

/** @type {(inputs: Roster_No_BookingsInputs) => LocalizedString} */
const ko_roster_no_bookings = en_roster_no_bookings;

/**
* | output |
* | --- |
* | "No bookings yet" |
*
* @param {Roster_No_BookingsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const roster_no_bookings = /** @type {((inputs?: Roster_No_BookingsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roster_No_BookingsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roster_no_bookings(inputs)
	if (locale === "es") return es_roster_no_bookings(inputs)
	if (locale === "fr") return fr_roster_no_bookings(inputs)
	if (locale === "de") return de_roster_no_bookings(inputs)
	if (locale === "ja") return ja_roster_no_bookings(inputs)
	if (locale === "zh") return zh_roster_no_bookings(inputs)
	if (locale === "ar") return ar_roster_no_bookings(inputs)
	if (locale === "id") return id_roster_no_bookings(inputs)
	if (locale === "it") return it_roster_no_bookings(inputs)
	if (locale === "ru") return ru_roster_no_bookings(inputs)
	if (locale === "pt") return pt_roster_no_bookings(inputs)
	return ko_roster_no_bookings(inputs)
});